import axios from '../../../axios';
import EvaluationFeedbackDTO from '../types/EvaluationFeedbackDTO';
import EvaluationTamplateDTO from '../types/EvaluationTamplateDTO';
import IEvaluationResponsePayload from '../types/IEvaluationResponsePayload';
import InformationCategoryDTO from '../types/InformationCategoryDTO';
import RtrTemplateDTO from '../types/RtrTemplateDTO';
import TemplateDTO from '../types/TemplateDTO';

const url = 'corphiringservice/api/evaluation-template';
const urls = 'corphiringservice/api/job-evaluation';
const feedBackUrl = 'corphiringservice/api/evaluation-response';
const infoCategoryUrl = 'corphiringservice/api/information-category';
const rtrEmailTemplateUrl = 'corphiringservice/api/rtrtemplate-email';
const infoSubmitCategoryUrl = 'corphiringservice/api/information-req-response';

export const getUserDefinedTemplates = () =>
  axios.get('candidatesearch/api/mail-templates/user-or-team-ids');
export const getPreDefinedTemplates = () => axios.get('candidatesearch/api/mail-templates');

export const getUserMailTemplatesByType = (type: string) => {
  return axios.get(`candidatesearch/api/mail-templates-user-by-type/${type}`);
};

export const getDefaultMailTemplatesByType = (type: string) => {
  return axios.get(`candidatesearch/api/mail-templates-default-template-by-type/${type}`);
};
export const getOnlyEmailTemplates = () => {
  return axios.get(`candidatesearch/api/mail-templates-only-email-templates`);
};

export const deleteTemplate = (templateId: any) =>
  axios.delete(`candidatesearch/api/mail-templates/${templateId}`);
export const favoriteTemplate = (templateId: any, flag: any) =>
  axios.post(`candidatesearch/api/mail-templates/favorite/${templateId}`, flag);
export const hideTemplate = (templateId: any, flag: any) =>
  axios.post(`candidatesearch/api/mail-templates/hide/${templateId}`, flag);
export const createTemplate = (templateData: TemplateDTO) =>
  axios.post('candidatesearch/api/mail-templates', templateData);

export const fetchEvaluationTemplate = (
  search: string | null,
  pageNo: number | null,
  pageSize: number | null,
  sortBy?: string,
  sortOrder?: string | null
) =>
  axios.get(
    `${url}/fetch?search=${search}&pageNo=${pageNo}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}`
  );

export const createAllEvaluationTemplate = (payload: any) => axios.post(`${url}/add`, payload);

export const updateAllEvaluationTemplate = (id: string, payload: EvaluationTamplateDTO) =>
  axios.put(`${url}/update/${id}`, payload);

export const deleteAllEvaluationTemplate = (templateId: any) =>
  axios.delete(`${url}/delete/${templateId}`);

export const getTemplateById = (id: string) => axios.get(`${url}/get/${id}`);

export const getAllTemplatesTaggedToJob = (id: string) =>
  axios.get(`corphiringservice/api/job-evaluation/fetch?jobId=${id}`);

export const getAllEvaluationTemplateList = (
  pageNo: number,
  pageSize: number,
  search: string | null,
  sortBy?: string,
  sortOrder?: string | null
) =>
  axios.get(
    `${url}/fetch?pageNo=${pageNo}&pageSize=${pageSize}&search=${search}&sortBy=${sortBy}&sortOrder=${sortOrder}`
  );

export const createEvaluationdFeedback = (evaluationFeedbackData: EvaluationFeedbackDTO) =>
  axios.post(`${feedBackUrl}/add`, evaluationFeedbackData);

export const getEvaluationTemplateByJobId = (jobId: string) =>
  axios.get(`${urls}/fetch?jobId=${jobId}`);

export const saveEvaluationResponse = (payload: IEvaluationResponsePayload) =>
  axios.post('corphiringservice/api/evaluation-response/add', payload);

export const getEvaluationTemplateById = (id: string) => axios.get(`${url}/get/${id}`);

export const getEvaluationResponseByInvitationId = (id: string) =>
  axios.get(`${feedBackUrl}/fetch-invitationId?invitationId=${id}`);

export const getAllInformationCategory = (
  pageNo: number,
  pageSize: number,
  search: string | null,
  sortBy?: string,
  sortOrder?: string | null
) =>
  axios.get(
    `${infoCategoryUrl}/fetchInfo?pageNo=${pageNo}&pageSize=${pageSize}&search=${search}&sortBy=${sortBy}&sortOrder=${sortOrder}`
  );

export const getAllInformationReqTemplates = () => axios.get(`${infoCategoryUrl}/fetch-all`);

export const getInformationReqTemplate = (id: string) => axios.get(`${infoCategoryUrl}/${id}`);
export const createAllInformationCategory = (payload: any) =>
  axios.post(`${infoCategoryUrl}/addInfo`, payload);

export const updateAllInformationCategory = (categoryId: string, payload: InformationCategoryDTO) =>
  axios.put(`${infoCategoryUrl}/update/${categoryId}`, payload);

export const deleteAllInformationCategory = (categoryId: any) =>
  axios.delete(`${infoCategoryUrl}/delete/${categoryId}`);

export const getAllRtrTemplate = (
  pageNo: number,
  pageSize: number,
  search: string | null,
  sortBy?: string,
  sortOrder?: string | null
) =>
  axios.get(
    `${rtrEmailTemplateUrl}/fetchInfo?pageNo=${pageNo}&pageSize=${pageSize}&search=${search}&sortBy=${sortBy}&sortOrder=${sortOrder}`
  );
export const createAllRtrTemplate = (payload: any) =>
  axios.post(`${rtrEmailTemplateUrl}/addEmail`, payload);

export const updateAllRtrTemplate = (rtrEmailTemplateId: string, payload: RtrTemplateDTO) =>
  axios.put(`${rtrEmailTemplateUrl}/update/${rtrEmailTemplateId}`, payload);

export const deleteAllRtrTemplate = (rtrEmailTemplateId: any) =>
  axios.delete(`${rtrEmailTemplateUrl}/delete/${rtrEmailTemplateId}`);

export const getAllInformationTemplateList = (
  pageNo: number,
  pageSize: number,
  search: string | null,
  sortBy?: string,
  sortOrder?: string | null
) =>
  axios.get(
    `${infoCategoryUrl}/fetchInfo?pageNo=${pageNo}&pageSize=${pageSize}&search=${search}&sortBy=${sortBy}&sortOrder=${sortOrder}`
  );

export const getInfoTemplateByJobId = (jobId: string) =>
  axios.get(`${infoCategoryUrl}/fetch?jobId=${jobId}`);

export const getInfoTemplateMappingsByJobIds = (jobIds: (string | undefined)[]) =>
  axios.post(`${infoCategoryUrl}/getbyjobids`, jobIds);
export const getEvaluationTemplateMappingsByJobIds = (jobIds: (string | undefined)[]) =>
  axios.post(`${urls}/getbyjobids`, jobIds);
export const fetchInfoTemplateByJobId = (jobId: string) =>
  axios.get(`${infoCategoryUrl}/getbyjobid/job/${jobId}`);
export const fetchEvalTemplateByJobId = (jobId: string) =>
  axios.get(`${urls}/getbyjobid/job/${jobId}`);

export const getRtrTemplateByJobId = (jobId: string) =>
  axios.get(`${rtrEmailTemplateUrl}/getrtrtemplate/job/${jobId}`);

export const getRtrTemplateByTemplateId = (templateId: number) =>
  axios.get(`${rtrEmailTemplateUrl}/getrtrtemplate/template/${templateId}`);

export const getSubmitInfoTemplateByJobId = (interactionId: string, informationCategory: string) =>
  axios.get(
    `${infoSubmitCategoryUrl}/getInfromationTemplate?interactionId=${interactionId}&informationCategory=${informationCategory}`
  );

export const getAllActiveInformationCategory = () => axios.get(`${infoCategoryUrl}/fetchactive`);

export const getAllEvauationTemplates = () => axios.get(url);

export const cancelRTRRequest = (id: number) => axios.get(`${infoSubmitCategoryUrl}/cancel/${id}`);
